import {
  Paper,
  Typography,
  Box,
  Stack,
  useMediaQuery,
  useTheme,
} from '@mui/material';

import { AppFormikSelect } from 'shared/components/AppComponents';

interface ClassificationDetialFormProps {
  test: any;
}

const ClassificationDetailForm: React.FC<
  ClassificationDetialFormProps
> = () => {
  const theme = useTheme();
  const match = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Paper variant="outlined" className="risk-management-wrapper">
      <Typography variant="h6">Classification Details</Typography>
      <Stack direction={match ? 'column' : 'row'} spacing={2}>
        <Box className="basic-information-likelihood">
          <AppFormikSelect
            name="vulnerability_category"
            className="rework-selection"
            notched={false}
            labelId="fix-selection-label"
            testid="solicitor-dropdown"
            MenuProps={{
              className: 'menu-fix-selection single-fix-rework',
            }}
            outerLabel
            placeholder="Select Category"
            notEmphasized
            notSelectablePlaceholder
            label="Category"
            items={[
              'Prompt Injection',
              'Data Poisoning',
              'Model Inversion',
              'Adversarial Example',
              'Supply Chain',
              'OSS Vulnerability',
              'Infrastructure Misconfiguration',
              'Authentication Bypass',
              'Authorization Breach',
              'Model Extraction',
              'Other',
            ]}
          />
        </Box>
        <Box className="basic-information-impact">
          <AppFormikSelect
            name="risk_rating"
            className="rework-selection"
            notched={false}
            labelId="fix-selection-label"
            testid="solicitor-dropdown"
            MenuProps={{
              className: 'menu-fix-selection single-fix-rework',
            }}
            outerLabel
            placeholder="Select rating"
            notEmphasized
            notSelectablePlaceholder
            label="Risk Rating"
            items={['Low', 'Moderate', 'High', 'Critical']}
          />
        </Box>
      </Stack>
      <Stack direction={match ? 'column' : 'row'} spacing={2}>
        <Box className="basic-information-likelihood">
          <AppFormikSelect
            name="environment"
            className="rework-selection"
            notched={false}
            labelId="fix-selection-label"
            testid="solicitor-dropdown"
            MenuProps={{
              className: 'menu-fix-selection single-fix-rework',
            }}
            outerLabel
            placeholder="Select environment"
            notEmphasized
            notSelectablePlaceholder
            label="Environment"
            items={['Development', 'Test', 'Production']}
          />
        </Box>
        <Box className="basic-information-impact">
          <AppFormikSelect
            name="lifecycle_stage_impacted"
            className="rework-selection"
            notched={false}
            labelId="fix-selection-label"
            testid="solicitor-dropdown"
            MenuProps={{
              className: 'menu-fix-selection single-fix-rework',
            }}
            outerLabel
            placeholder="Select lifecycle stage"
            notEmphasized
            notSelectablePlaceholder
            label="Lifecycle Stage Impacted"
            items={['Training', 'Fine-Tuning', 'Inference', 'Post-Processing']}
          />
        </Box>
      </Stack>
      <Stack direction={match ? 'column' : 'row'} spacing={2}>
        <Box className="basic-information-likelihood">
          <AppFormikSelect
            name="status"
            className="rework-selection"
            notched={false}
            labelId="fix-selection-label"
            testid="solicitor-dropdown"
            MenuProps={{
              className: 'menu-fix-selection single-fix-rework',
            }}
            outerLabel
            placeholder="Select status"
            notEmphasized
            notSelectablePlaceholder
            label="Status"
            items={[
              'Detected',
              'Triaged',
              'Categorized',
              'Remediation Planned',
              'In Remediation',
              'Mitigated',
              'Verified',
              'Risk Accepted',
              'Reopened',
            ]}
          />
        </Box>
        <Box className="basic-information-impact">
          <AppFormikSelect
            name="confidentiality_classification"
            className="rework-selection"
            notched={false}
            labelId="fix-selection-label"
            testid="solicitor-dropdown"
            MenuProps={{
              className: 'menu-fix-selection single-fix-rework',
            }}
            outerLabel
            placeholder="Select classification"
            notEmphasized
            notSelectablePlaceholder
            label="Confidentiality Classification"
            items={['Internal Only', 'Vendor Sharing', 'Public']}
          />
        </Box>
      </Stack>
    </Paper>
  );
};

export default ClassificationDetailForm;
